import { ReactComponent as LogoutIcon } from 'core/assets/images/icones/logoutIcon.svg'
import { UserContext } from 'core/contexts/UserContext'
import { UseKeycloakService } from 'core/packages/KeycloakProvider'
import { t } from 'i18next'
import { useContext } from 'react'

export const Logout = () => {
  const kc = UseKeycloakService()
  const { clearUserSession } = useContext(UserContext)

  const handleLogout = () => {
    clearUserSession()
    // logout() retourne une Promise (rejetée par ex. en cas de 504 sur l'endpoint Keycloak).
    // On l'attrape pour éviter un unhandled promise rejection.
    kc.getKc()
      .logout({ redirectUri: window.location.origin })
      .catch((error: unknown) => {
        console.error('Keycloak logout failed', error)
      })
  }

  return (
    <LogoutIcon
      className="logout-option ml-[15px]"
      onClick={handleLogout}
      aria-label={t('layout.logout')}
    />
  )
}
